module.exports = __webpack_public_path__ + "img/design.d0dedc3.webp";